import React, { useEffect, useState } from 'react';
import { isPWA } from '../utils/pwaUtils';

interface PWAWrapperProps {
  children: React.ReactNode;
}

const PWAWrapper: React.FC<PWAWrapperProps> = ({ children }) => {
  const [isLandscape, setIsLandscape] = useState(false);
  const [showPWAFeatures, setShowPWAFeatures] = useState(false);

  useEffect(() => {
    const pwa = isPWA();
    // Check if running as PWA
    setShowPWAFeatures(pwa);

    // Handle orientation changes
    const handleOrientationChange = () => {
      // Use setTimeout to ensure the orientation has actually changed
      setTimeout(() => {
        const orientation = window.screen?.orientation?.angle ?? window.orientation ?? 0;
        setIsLandscape(Math.abs(orientation) === 90);
      }, 100);
    };

    // Initial orientation check
    handleOrientationChange();

    // Listen for orientation changes
    window.addEventListener('orientationchange', handleOrientationChange);
    window.addEventListener('resize', handleOrientationChange);

    return () => {
      window.removeEventListener('orientationchange', handleOrientationChange);
      window.removeEventListener('resize', handleOrientationChange);
    };
  }, []);

  return (
    <>
      {showPWAFeatures && isLandscape && (
        <div className="landscape-warning">
          <div>
            <h2>📱 Please rotate your device</h2>
            <p>This app is designed for portrait orientation.</p>
            <p>Please rotate your device to portrait mode for the best experience.</p>
          </div>
        </div>
      )}
      <div className={`pwa-content-wrapper${showPWAFeatures && isLandscape ? ' portrait-content' : ''}`}>
        {children}
      </div>
    </>
  );
};

export default PWAWrapper;
